import { ExternalToast } from "sonner";

export const TOASTER_CONFIG = {
  position: "top-right" as const,
  duration: 4000,
  visibleToasts: 3,
  toastOptions: {
    style: {
      background: "#ffffff",
      color: "#0f0f0f",
      border: "1px solid rgba(0, 0, 0, 0.08)",
    },
  } as ExternalToast,
};
